/* unplugin-vue-components disabled */import { render } from "./Nyoni.vue?vue&type=template&id=4a7a912b"
import script from "./Nyoni.vue?vue&type=script&lang=js"
export * from "./Nyoni.vue?vue&type=script&lang=js"

import "./Nyoni.vue?vue&type=style&index=0&id=4a7a912b&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__